<template>
  <div>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(data)" v-if="data.constructor.name === 'String'">
      <span>{{ $t(local + data) }}</span>
    </vs-chip>
    <div v-if="data.constructor.name === 'Array'" v-for="s in data" :key="s">
      <vs-chip class="ag-grid-cell-chip" :color="chipColor(s)">
        <span>{{ $t(local + s) }}</span>
      </vs-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CellBadges',
  props: {
    data: {
      type: [String, Array],
      required: true
    },
    local: {
      type: String,
      required: true
    }
  },
  computed: {
    chipColor() {
      const success = ['active', 'approved', 'admin', 'system', 'paid', 'cash_paid']
      const warning = ['inactive', 'pending', 'user']
      const danger = ['rejected', 'unspecified', 'guest', 'unpaid']
      const dark = ['unspecified']

      return value => {
        if (success.includes(value)) return 'success'
        else if (warning.includes(value)) return 'warning'
        else if (danger.includes(value)) return 'danger'
        else if (dark.includes(value)) return 'dark'
        else return 'primary'
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-dark {
    background: rgba(var(--vs-dark), 0.15);
    color: rgba(var(--vs-dark), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-primary {
    background: rgba(var(--vs-primary), 0.15);
    color: rgba(var(--vs-primary), 1) !important;
    font-weight: 500;
  }
}
</style>
